import { Module } from 'vuex'
import { RootState, Collection as CollectionType } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useWorkoutCollectionHttp } from '@/core/api/workout-collections'
import { WorkoutCollectionModel, WorkoutCollectionPayload } from '@/core/models/workout-collection'

export type WorkoutCollectionList = {
    data: Array<WorkoutCollectionModel>,
    meta?: MetaPayload,
    links?: any
}

const state: WorkoutCollectionList = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const workoutCollectionList: Module<WorkoutCollectionList, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: WorkoutCollectionList, payload: CollectionType) => {
            state.data = <any>[]
            payload.data.forEach((item: WorkoutCollectionPayload) => {
                state.data.push(new WorkoutCollectionModel(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useWorkoutCollectionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: WorkoutCollectionList): WorkoutCollectionList => {
            return state
        }
    }
}
